import fetchJson from 'UTILS/fetch/fetchJson';
import ShopifyApiError from '../ShopifyApiError';
import customErrorHandler from '../customErrorHandler';

/**
 * The change.js endpoint is able to change the quantity and properities object of a cart line item
 * 
 *** IMPORTANT *** If the quantity requested is greater than what's available, 
  quantity adjusts automatically to the number of items in stock. No error thrown so it's not possible to responsed & notify user

 * Only items already in your cart can be changed, and only one line item at a time can be changed.
 * Always use line item keys (opposed to variant ids) since there can be multiple line items with the same variant_id 
   the same id can be in cart multiple times as a result of automatic discounts or the same product variant being added with different properties.
 * The cart will have multiple products with the same variant_id when that same variant has been added with different line item properties, or when automatic discounts have been applied to an instance of the variant

 * To make a line item property private, append an underscore (_) to the key.
 * @param {Object} postObj - The postObj which will be part of the config for the postJSON function.
 * @param {string} postObj.id - Value from line_item.key (The shopify docs instruct the use of the `line` prop when there are multiple instances of the same variant in the cart but keys are only accepted by this function since they are more reliable)
 * @param {Number} postObj.quantity [optional]- New quantity for the item being updated. Not needed if only updating properties. If no quantity is provided the cart will reduce the item to a min quantity of 1.
 * @param {Object} postObj.properties [optional]- Properties associated with the item denoted by key value pairs. Object provided will overwrite any existing properties object.
 * @return {Promise<json | Error>} Returns a Promise that will resolve or reject to json or an Error. Be sure to handle the error in the parent function.
 */
const changeCartLineItem = async ({ id, quantity = null, properties = null }) => {
  const payload = { id };
  if (quantity !== null && quantity >= 0) {
    payload.quantity = quantity;
  }
  if (properties) payload.properties = properties;

  return fetchJson({
    url: `${window.Shopify.routes.root}cart/change.js`,
    config: {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    options: {
      customErrorHandler,
      bypassErrors: [ShopifyApiError],
    },
  });
};

export default changeCartLineItem;
